function getEnv() {
  const appEnvironment = import.meta.env.VITE_APP_env;
  switch (appEnvironment) {
    case 'staging':
    case 'uat':
      return appEnvironment;
    case 'production':
      return 'production';
    default:
      return 'development';
  }
}

export const AppSettings = Object.freeze({
  isProduction: import.meta.env.VITE_APP_env === 'production',
  env: getEnv(),
});
